export const SAVE_EDITED_LOAN_APPLICATION = 'SAVE_EDITED_LOAN_APPLICATION';
